import React from 'react'
import Loading from '../../../Loder';
const ReferralModal = React.lazy(() => import('../../account/ReferralModal'));

const CareersReferAFriendPage = () => {
  return (
    <div className='container pt-5 careerscontainer'>
      <React.Suspense fallback={<Loading />}>
        <ReferralModal from="Careers" />
      </React.Suspense>
    </div>
  )
}

export default CareersReferAFriendPage